<template lang="html">
  <div class="edit-comment" v-if="list.length != 0">
    <div class="item" v-for="i in list" :key="'edit-comment'+i.create_time">
      <!-- <i class="iconfont">&#xe6c7;</i> -->
      <img :src="$store.state.static_img_url+'mobile/pic/bianjipinglun.png'">
      <p class="title">{{i.title}}</p>
      <p v-html="i.content" class="v-content">
      </p>
      <div class="comment-img-list">
        <div v-for="j in i.images_arr" :key="j">
          <img :preview="i.module_id+j" :src="j | logo_show" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['list']
}
</script>

<style lang="stylus" scoped>
.edit-comment
  margin-top: .3rem;
  border: 1px dashed #ddd;
  padding: .3rem;
  .item
    position: relative;
    >img
      width: .28rem;
      height: .28rem;
      margin-top: .08rem;
      position: absolute;
      top: 0;
      left: 0;
    p
      font-size: .28rem;
      color: #333;
      line-height: .44rem;
      margin-left: .44rem;
      word-break: break-all;
    p.title
      font-weight: bold;
      margin-bottom: .04rem;
    .v-content
      img
        max-width: 100%;
        height: auto;
    .comment-img-list
      display: flex;
      flex-wrap: wrap;
      margin-left: 0.44rem;
      div
        width: 2rem;
        height: 1.44rem;
        min-width: 2rem;
        min-height: 1.44rem;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: .2rem;
        margin-right: .2rem;
        img
          max-width: 100%;
          max-height: 100%;
          display: block;
  .item+.item
    border-top: 1px dashed #E9E9E9;
    margin-top: .3rem;
    padding-top: .3rem;
    img
      top: .3rem;
</style>
